import Clickable from '@sdk/components/primitives/Clickable';
import FlexCenteredStyle from '@sdk/components/ui/FlexCenteredStyle';
import Row from '@sdk/components/ui/spacing/Row';
import styled from 'styled-components';

export const ProgressBarContainer = styled(Row)`
  position: relative;
  ${FlexCenteredStyle};
`;

export const ChevronContainer = styled(Clickable)`
  padding-left: 10px;
`;

export const CenterdText = styled(Row)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  ${FlexCenteredStyle};
`;
